export class Confirmation
{
    header:string;
    message:string;
    okText:string;
    cancelText:string;
}